<template>
  <Index></Index>
</template>

<script>
import Index from '@/components/layout/router-view';
export default {
  components: {
    Index
  }
};
</script>
<style lang='scss' scoped>
.keep-alive {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
